<div class="fh-page">

  <div class="fh-action-head" *ngIf="isListRoute">
    <button
      class="rp-button rp-filled rp-primary rp-small"
      *ngIf="isCompaniesRoute && canCreateCompany"
      (click)="navigateToCreateCompany()"
    >
      <span class="content-icon one-icon-add"></span>
      New company
    </button>

    <button
      class="rp-button rp-filled rp-primary rp-small"
      *ngIf="!isCompaniesRoute && canCreatePO"
      (click)="navigateToCreate()"
    >
      <span class="content-icon one-icon-add"></span>
      New Purchase Order
    </button>
  </div>

  <div class="fh-banner" *ngIf="showBanner && bannerConfig?.enabled">
    <div class="fh-banner__content">
      <p class="fh-banner__title">{{ bannerConfig?.title }}</p>
      <p class="fh-banner__desc">
        {{ bannerConfig?.description }}
      </p>
      <button
        class="rp-button rp-filled rp-primary rp-small"
        (click)="openBannerAction()"
        *ngIf="bannerConfig?.button"
      >
        {{ bannerConfig?.button.label }}
      </button>
    </div>

    <div class="fh-banner__decoration" aria-hidden="true">
      <svg
        class="fh-banner__decoration-svg"
        width="268"
        height="176"
        viewBox="0 0 268 176"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMaxYMid meet"
      >
        <path d="M61.1035 279.697L33.7776 148.392C28.8044 124.494 44.0085 101.09 67.7893 95.8672L104.181 270.732C106.656 282.627 99.0198 294.277 87.1244 296.753C75.229 299.228 63.579 291.592 61.1035 279.697Z" stroke="#4589FF"/>
        <path d="M23.4131 98.5891C20.9377 86.6938 28.5739 75.0438 40.4693 72.5682C52.3646 70.0927 64.0145 77.7291 66.4902 89.6243L67.5843 94.8818L24.5073 103.847L23.4131 98.5891Z" fill="#4589FF" stroke="#4589FF"/>
        <rect x="18.727" y="76.0717" width="44" height="44" transform="rotate(-101.756 18.727 76.0717)" stroke="#4589FF"/>
        <rect x="9.55854" y="32.0155" width="44.0681" height="44" rx="22" transform="rotate(-101.756 9.55854 32.0155)" stroke="#4589FF"/>
        <path d="M97.0289 187.311C94.5535 175.415 102.19 163.765 114.085 161.29C125.98 158.814 137.63 166.451 140.106 178.346L141.2 183.603L98.123 192.568L97.0289 187.311Z" fill="#4589FF" stroke="#4589FF"/>
        <rect x="92.3427" y="164.793" width="44" height="44" transform="rotate(-101.756 92.3427 164.793)" stroke="#4589FF"/>
        <rect x="83.1743" y="120.737" width="44.0681" height="44" rx="22" transform="rotate(-101.756 83.1743 120.737)" stroke="#4589FF"/>
        <path d="M64.925 33.0481L58.2454 0.951609C55.7701 -10.9436 63.4062 -22.5938 75.3015 -25.0693C87.1968 -27.5448 98.8467 -19.9083 101.322 -8.01318L117.067 67.6432C93.1771 72.3412 69.8984 56.9459 64.925 33.0481Z" stroke="#4589FF"/>
        <path d="M166.424 255.712L136.525 112.044C131.075 85.8556 147.749 60.2041 173.821 54.5042L213.65 245.884C216.364 258.925 207.992 271.697 194.952 274.411C181.911 277.125 169.138 268.753 166.424 255.712Z" stroke="#4589FF"/>
        <path d="M127.372 57.6609C124.896 45.7656 132.532 34.1155 144.428 31.64C156.323 29.1644 167.973 36.8009 170.449 48.6961L171.543 53.9536L128.466 62.9184L127.372 57.6609Z" fill="#4589FF" stroke="#4589FF"/>
        <rect x="122.685" y="35.144" width="44" height="44" transform="rotate(-101.756 122.685 35.144)" stroke="#4589FF"/>
        <path d="M219.715 246.745L213.036 214.649C208.063 190.751 223.267 167.347 247.047 162.124L262.792 237.78C265.268 249.676 257.632 261.326 245.736 263.801C233.841 266.277 222.191 258.64 219.715 246.745Z" stroke="#4589FF"/>
        <path d="M202.671 164.846C200.196 152.951 207.832 141.301 219.728 138.825C231.623 136.35 243.273 143.986 245.748 155.881L246.843 161.139L203.766 170.103L202.671 164.846Z" fill="#4589FF" stroke="#4589FF"/>
        <rect x="197.985" y="142.329" width="44" height="44" transform="rotate(-101.756 197.985 142.329)" stroke="#4589FF"/>
        <rect x="188.817" y="98.2724" width="44.0681" height="44" rx="22" transform="rotate(-101.756 188.817 98.2724)" stroke="#4589FF"/>
        <path d="M170.568 10.5833L163.888 -21.5132C161.413 -33.4085 169.049 -45.0586 180.944 -47.5342C192.839 -50.0097 204.489 -42.3732 206.965 -30.478L222.71 45.1783C198.82 49.8764 175.541 34.481 170.568 10.5833Z" stroke="#4589FF"/>
      </svg>
    </div>

    <button class="fh-banner__close" (click)="closeBanner()" aria-label="Close banner">
      <span class="one-icon-close-v2"></span>
    </button>
  </div>

  <nav class="fh-tabs" *ngIf="isListRoute">
    <a
      class="fh-tabs__tab"
      routerLink="./companies"
      routerLinkActive="fh-tabs__tab--active"
      *ngIf="canViewCompanies"
    >
      Companies
    </a>
    <a
      class="fh-tabs__tab"
      routerLink="./purchase-orders"
      routerLinkActive="fh-tabs__tab--active"
      [routerLinkActiveOptions]="{ exact: true }"
      *hasPermission="'financial-hub/purchase-orders'"
    >
      Purchase orders
    </a>
  </nav>

  <div class="fh-content">
    <router-outlet></router-outlet>
  </div>

</div>
